import gameNames from '../../hub/data/GameIds';

export const initialState = {
  levelScore: 0,
  currentLevel: 0,
  levelType: null,
  lastLevelUnlocked: 0,
  hasOnboarded: {
    compound: false,
    syllable: false,
    onsetrime: false,
  },
};

const score = (state = initialState, action) => {
  if (action.gameId !== gameNames.WORDBOTS) {
    return state;
  }

  switch (action.type) {
    case 'WORDBOTS_INCREMENT_LEVEL_SCORE': {
      const { levelScore, lastLevelUnlocked } = action.payload;

      return {
        ...state,
        levelScore,
        lastLevelUnlocked,
      };
    }

    case 'WORDBOTS_GO_TO_LEVEL': {
      const { level, levelType } = action.payload;

      return {
        ...state,
        currentLevel: +level,
        levelType,
        levelScore: 0,
      };
    }

    case 'WORDBOTS_ONBOARDING_COMPLETE':
      return {
        ...state,
        hasOnboarded: {
          ...state.hasOnboarded,
          [action.payload]: true,
        },
      };

    default:
      return state;
  }
};

export default score;
